import React from "react";
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";
import "./FieldStyles.css";
import PCBQtyValueRow from "./PCBQtyValue/PCBQtyValueRow";

const qtyValueRows = [
    [5,10,15,20,25],
    [30,50,75,100,125],
    [150,200,250,300,400],
    [450,500,600,700,800],
    [900,1000],
    // [900,1000,1500,2000,2500],
    // [3000,3500,4000,4500,5000],
    // [5500,6000,6500,7000,7500],
    // [8000,8500,9000,9500,10000],
    // [11000,12000,13000,14000,15000],
    // [16000,17000,18000,19000,25000],
    // [30000,40000,50000,60000,70000],
    // [80000],

];

const qtyValueRowsMobi = [5,10,15,20,25,30,50,75,100,125,150,200,250,300,400,450,500,600,700,800,900,1000];


const PCBQuantity = (props) => {
    return (
        <div className="row">
            <div className="col-md-12 no-padding">
                <div className="pcb-details-div">
                    <div className="col-md-3 text-right content-item-heading">
                        <FormattedMessage id="app.pcb-quotation.pcb-quantity"
                                          defaultMessage="PCB Quantity"
                                          description=""
                        />
                        &nbsp; &nbsp;
                        <Link id="pcbQty-qLink"
                            to={{pathname:"https://kitcutlabo.com/manufacturing-number/"}} target="_self"
                            className="glyphicon glyphicon-question-sign question-link"></Link>
                    </div>
                    <div className="col-md-2 pcb-quantity div-dimension">
                        <select name="pcbQuantity" onChange={props.setQuantity}
                                value={props.selectedQty} className="form-control pcb-qty-select mobile-view">
                            {
                                qtyValueRowsMobi.map((qtyVal)=> {
                                return <option key={qtyVal} value={qtyVal}>{qtyVal}</option>;
                            })}
                        </select>
                        <label className="dropdown qty-label web-view">

                            <div className="dd-button">
                                <div className="pull-left">{props.selectedQty}</div>
                                <div className="pull-right text-small down-arrow">&nbsp;&#9660;</div>

                            </div>

                            <input type="checkbox" className="dd-input" id="test"/>
                                <ul className="dd-menu">
                                    {qtyValueRows.map((value => {
                                        return(
                                   <li key={value}>
                                      <PCBQtyValueRow
                                            row = {value}
                                            setPCBQuantity = {props.setPCBQuantity}
                                            selectedQty = {props.selectedQty}
                                      />
                                   </li>)
                                    }))}
                                </ul>

                        </label>
                    </div>
                    <div className="col-md-5">
                    </div>
                </div>
            </div>
        </div>
    )
};

export default PCBQuantity;



// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/PCBQuotationForm/PCBQuotationFormFields/PCBQuantity.js